import { render } from "./SaleSharedFeesTab.vue?vue&type=template&id=0af74154&scoped=true"
import script from "./SaleSharedFeesTab.vue?vue&type=script&lang=js"
export * from "./SaleSharedFeesTab.vue?vue&type=script&lang=js"

import "./SaleSharedFeesTab.vue?vue&type=style&index=0&id=0af74154&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af74154"]])

export default __exports__